import app from 'locales/ar/app.json';
import common from 'locales/ar/common.json';
import validation from 'locales/ar/validation.json';
import dashboard from 'locales/ar/dashboard.json';
import tutorials from 'locales/ar/tutorials.json';
import myGiftCards from 'locales/ar/my-gift-cards.json';
import orderHistory from 'locales/ar/order-history.json';
import users from 'locales/ar/users.json';
import redemptions from 'locales/ar/redemptions.json';
import auth from 'locales/ar/auth.json';
import finance from 'locales/ar/finance.json';
import getStarted from 'locales/ar/get-started.json';
import termsAndConditions from 'locales/ar/terms-and-conditions.json';
import privacyPolicy from 'locales/ar/privacy-policy.json';
import subscription from 'locales/ar/subscription.json';

export const ar_namespaces = {
  app,
  common,
  validation,
  dashboard,
  tutorials,
  'my-gift-cards': myGiftCards,
  'order-history': orderHistory,
  users,
  redemptions,
  auth,
  finance,
  subscription,
  'get-started': getStarted,
  'terms-and-conditions': termsAndConditions,
  'privacy-policy': privacyPolicy,
};
